var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.AkamaiAmp = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    var ret = this.player.currentTime
    if (this.plugin.getIsLive()) {
      ret = this.player.absoluteCurrentTime
    }
    return ret
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    var ret = this.player.playbackRate
    if (this.flags.isPaused) {
      ret = 0
    }
    return ret
  },

  /** Override to return Frames Per Second (FPS) */
  getFramesPerSecond: function () {
    var ret = null
    if (this.player.qualityLevels[this.player.quality]) {
      ret = this.player.qualityLevels[this.player.quality].attrs['FRAME-RATE']
    }
    return ret
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return this.player.mediaElement.webkitDroppedFrameCount
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var ret = null
    if (this.player.qualityLevels[this.player.quality]) {
      ret = this.player.qualityLevels[this.player.quality].bitrate
    }
    return ret
  },

  /** Override to return rendition */
  getRendition: function () {
    var ret = null
    if (this.player.qualityLevels[this.player.quality]) {
      var quality = this.player.qualityLevels[this.player.quality]
      ret = youbora.Util.buildRenditionString(quality.width, quality.height, quality.bitrate)
    }
    return ret
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    var ret = this.player.isLive
    var quality = this.player.qualityLevels[this.player.quality]
    if (quality && quality.details && typeof quality.details.live !== 'undefined') {
      ret = quality.details.live
    }
    return ret
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.src
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Akamai - Adaptive Media Player'
  },

  getCodecs: function () {
    var quality = this.player.qualityLevels[this.player.quality]
    if (quality) {
      this.plugin.options['content.encoding.videoCodec'] = quality.videoCodec
      this.plugin.options['content.encoding.audioCodec'] = quality.audioCodec
    }
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // References
    this.references = {
      'waiting': this.setAdsAdapterListener.bind(this),
      'playrequest': this.playListener.bind(this),
      'pause': this.pauseListener.bind(this),
      'paused': this.pauseListener.bind(this),
      'playing': this.playingListener.bind(this),
      'error': this.errorListener.bind(this),
      'seeking': this.seekingListener.bind(this),
      'seeked': this.seekedListener.bind(this),
      'ended': this.endedListener.bind(this),
      'timeupdate': this.timeupdateListener.bind(this),
      'adbreakend': this.endAdListener.bind(this),
      'qualitychange': this.qualityChangeListener.bind(this)
    }

    // Register listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.addEventListener(key, this.references[key])
      }.bind(this))
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      Object.keys(this.references).forEach(function (key) {
        this.player.removeEventListener(key, this.references[key])
      }.bind(this))
      this.references = {}
    }
  },

  setAdsAdapterListener: function (e) {
    if (!this.plugin.getAdsAdapter()) {
      if (typeof google !== 'undefined') {
        if (this.player.ads.moduleName === 'ima') { // IMA
          this.plugin.setAdsAdapter(new youbora.adapters.AkamaiIma(this.player.ads, this))
        } else if (this.player.ads._target) { // DAI
          this.plugin.setAdsAdapter(new youbora.adapters.AkamaiDaiIma(this.player.ads, this))
        }
      }
      /* if (typeof tv !== 'undefined' && this.player.freewheel && !this.plugin.getAdsAdapter()) { // Freewheel
        this.plugin.setAdsAdapter(new youbora.adapters.AkamaiFw(this.player.freewheel))
      } */
    }
  },

  qualityChangeListener: function (e) {
    this.fireBufferEnd()
    if (this.monitor) {
      this.monitor.skipNextTick()
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
    if (!this.flags.isJoined) {
      this.getCodecs()
    }
  },

  endAdListener: function (e) {
    if (this.plugin.getAdsAdapter()) {
      this.plugin.getAdsAdapter().fireStop()
    }
    this.fireResume()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireStart()
      if (!this.flags.isJoined) {
        this.getCodecs()
        this.fireJoin()
      }
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
    if (this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().flags.isJoined) {
      this.plugin.getAdsAdapter().firePause()
    }
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    if (!this.plugin.getAdsAdapter() || !this.plugin.getAdsAdapter().flags.isStarted) {
      this.fireResume()
    } else if (this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().flags.isJoined) {
      this.plugin.getAdsAdapter().fireResume()
    }
    // this.fireSeekEnd()
    this.fireBufferEnd()
    if (!this.flags.isJoined) {
      this.getCodecs()
      this.fireJoin()
    }
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.data.code, e.data.message)
    if (e.data.metadata.fatal || e.data.code === 2) {
      this.plugin.fireStop()
    }
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    if (!this.player.getPaused()) {
      this.fireSeekEnd()
    }
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
})

module.exports = youbora.adapters.AkamaiAmp
